import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { get as persistableGet, remove, set as persistableSet } from '@square/dashboard-utilities/utils/persistable';
export function setWithExpiry(key, value, ttl) {
  const now = new Date();

  // object stored contains value and expiry time
  const item = {
    value,
    expiry: now.getTime() + ttl
  };
  persistableSet(key, JSON.stringify(item), OneTrustConsent.FUNCTIONAL);
}
export function getWithExpiry(key) {
  const objStr = persistableGet(key, OneTrustConsent.FUNCTIONAL);
  // if the item doesn't exist, return null
  if (!objStr) {
    return null;
  }
  const obj = JSON.parse(objStr);
  const now = new Date();

  // compare the expiry time of the item with the current time
  if (now.getTime() > obj.expiry) {
    // If the item is expired, delete from storage and return null
    remove(key);
    return null;
  }
  return obj.value;
}